(() => {
    document.addEventListener('DOMContentLoaded', (event) => {

        const switches = document.querySelectorAll('.bc-tab-head > div > [data-switch]');


        switches.forEach(s => {
            s.addEventListener('click', () => {
                const currentActive = document.querySelector('.bc-tab-active');
                if (currentActive) {
                    currentActive.classList.remove('bc-tab-active');

                    const currentProgram = document.querySelector(`[data-program="${currentActive.dataset.switch}"]`);
                    if (currentProgram)
                        currentProgram.classList.add('hidden');
                }

                s.classList.add('bc-tab-active');
                const program = document.querySelector(`[data-program="${s.dataset.switch}"]`);
                if (program)
                    program.classList.remove('hidden');
            });
        });
    })
})();
